export default "__VITE_ASSET__fUhefx95__"